export const FETCH = 'PAYMENTS/WITHDRAW_FEES_AND_MIN/FETCH'
export const FETCH_SUCCESS = 'PAYMENTS/WITHDRAW_FEES_AND_MIN/FETCH_SUCCESS'
